// extracted by mini-css-extract-plugin
export var dropdownIcon = "_n2-6";
export var imgContainer = "_n2-3";
export var menuIcon = "_n2-5";
export var pillWrapper = "_n2-2";
export var pillsContainer = "_n2-1";
export var subscriptionCard = "_n2-0";
export var subscriptionLogo = "_n2-4";